// Wrapper for lazy loading PayslipPDF to avoid Firefox issues
// Firefox has problems with @react-pdf/renderer's font handling at load time

let pdfModule = null;
let loadingPromise = null;

// Check if running in Firefox
export const isFirefox = () => {
  return typeof navigator !== 'undefined' && 
    navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
};

// Lazy load the PDF module
const loadPDFModule = async () => {
  if (pdfModule) {
    return pdfModule;
  }
  
  if (loadingPromise) {
    return loadingPromise;
  }

  loadingPromise = import('./PayslipPDF').then(module => {
    pdfModule = module;
    return module;
  });

  return loadingPromise;
};

// Wrapper for generatePayslipPDF
export const generatePayslipPDF = async (payslip, employee, client) => {
  try {
    const module = await loadPDFModule();
    return module.generatePayslipPDF(payslip, employee, client);
  } catch (error) {
    console.error('Error loading PDF module:', error);
    if (isFirefox() && error.message?.includes('invalid character')) {
      return { 
        success: false, 
        error: 'PDF generation is not supported in Firefox. Please use Chrome or Edge.' 
      };
    }
    return { success: false, error: error.message };
  }
};

// Wrapper for printPayslipPDF
export const printPayslipPDF = async (payslip, employee, client) => {
  try {
    const module = await loadPDFModule();
    return module.printPayslipPDF(payslip, employee, client);
  } catch (error) {
    console.error('Error loading PDF module:', error);
    if (isFirefox() && error.message?.includes('invalid character')) {
      return { 
        success: false, 
        error: 'PDF printing is not supported in Firefox. Please use Chrome or Edge.' 
      };
    }
    return { success: false, error: error.message };
  }
};
